var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-move-to-top",
  "use": "ring-icon-move-to-top-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-move-to-top\"><path d=\"M6.697 4.442h5.478v2.004a.402.402 0 0 0 .686.284l3.021-3.022a.402.402 0 0 0 0-.568L12.861.118a.402.402 0 0 0-.686.284v2.24H6.696a6.662 6.662 0 1 0 0 13.324v-1.801a4.861 4.861 0 0 1 0-9.723zm1.718 9.808h7.583v1.6H8.415z\" /><path d=\"M8.415 9.095h7.583v1.6H8.415z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id